import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import { ConfigPageContainer, MainContainer, CircularProgressContainer } from './ConfigPage.styled';
import { useStore } from '../../../../../hooks';
import { Alert, Scrollbar, CircularProgress } from '@ann/web-components';
import ProfileImageSection from './components/ProfileImageSection';
import BasicInfoSection from './components/BasicInfoSection';
import ChatStartersSection from './components/ChatStartersSection';
import ModelSection from './components/ModelSection';
import TagsSection from './components/TagsSection';

const ConfigPage = observer(() => {
    const { playgroundConfigStore } = useStore()

    if (playgroundConfigStore.agentStore.isLoading) {
        return <CircularProgressContainer>
            <CircularProgress size="xl" />
        </CircularProgressContainer>;
    }

    if (playgroundConfigStore.error) {
        return <div>Error: {playgroundConfigStore.error}</div>;
    }

    return (
        <MainContainer>
            <Scrollbar size="small">
                <ConfigPageContainer>
                    {/*
                    <ProfileImageSection
                        imageUrl={playgroundConfigStore.agentStore.metadata?.imageUrl || ''}
                        setImageUrl={(url) => {
                            playgroundConfigStore.agentStore.metadata = {
                                ...playgroundConfigStore.agentStore.metadata,
                                imageUrl: url
                            };
                        }}
                        agentName={playgroundConfigStore.agentStore.name || ''}
                    />
                    */}

                    <BasicInfoSection
                        name={playgroundConfigStore.agentStore.name || ''}
                        description={playgroundConfigStore.agentStore.description || ''}
                        agentType={playgroundConfigStore.agentStore.type || ''}
                        category={playgroundConfigStore.agentStore.category || ''}
                        availableAgentTypes={playgroundConfigStore.availableAgentTypes}
                        availableCategories={playgroundConfigStore.availableCategories}
                        onNameChange={playgroundConfigStore.agentStore.setName}
                        onDescriptionChange={playgroundConfigStore.agentStore.setDescription}
                        onTypeChange={playgroundConfigStore.agentStore.setType}
                        onCategoryChange={playgroundConfigStore.agentStore.setCategory}
                    />

                    <ChatStartersSection
                        chatStarters={playgroundConfigStore.agentStore.starters}
                        onAddStarter={playgroundConfigStore.agentStore.addStarter}
                        onRemoveStarter={playgroundConfigStore.agentStore.removeStarter}
                    />

                    {/* <ModelSection
                        model={playgroundConfigStore.llmModel}
                        availableModels={playgroundConfigStore.availableLLMModels}
                        onModelChange={playgroundConfigStore.setLLMModel}
                    /> */}

                    {/* <TagsSection
                        tags={playgroundConfigStore.agentStore.tags ? playgroundConfigStore.agentStore.tags.split(',').filter(Boolean) : []}
                        onAddTag={playgroundConfigStore.agentStore.addTag}
                        onRemoveTag={playgroundConfigStore.agentStore.removeTag}
                    /> */}

                    {playgroundConfigStore.agentStore.showSavingAlert && (
                        <Alert
                            title="Autosave"
                            description="Your changes are saving..."
                            severity="info"
                            maxWidth="500px"
                            closable={false}
                            autoClose={true}
                            autoCloseDelay={3000}
                        />
                    )}
                </ConfigPageContainer>
            </Scrollbar>
        </MainContainer>
    );
});

export default ConfigPage;
